(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/bankid/assets/javascripts/views/bankid.js') >= 0) return;  svs.modules.push('/components/app/bankid/assets/javascripts/views/bankid.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.app.bankid.views.BankID = Marionette.View.extend({
    template: function(data) {
      return svs.app.bankid.templates.bankid(data);
    },
    ui: {
      ast: '#ast'
    },
    modelEvents: {
      'change:progressText': 'render'
    },
    getBankIDStartParams: function() {
      var startParams;
      var autoStartToken = this.getOption('autoStartToken');
      var isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp') ?
          svs.core.config.data.svsconfig.isNativeApp :
          false;
      if (svs.core.detect.os.android()) {
        startParams =
          'intent:///?autostarttoken=' +
          autoStartToken +
          '&redirect=null#Intent;scheme=bankid;package=com.bankid.bus;end';
      } else if (isNativeApp) {
        startParams =
          'bankid:///?autostarttoken=' +
          autoStartToken +
          '&redirect=' +
          encodeURIComponent(window.location.href.replace(/https?/i, svs.core.detect.tenant('tb') ? 'spelbutiken.bankid' : 'spelbutikenlb.bankid'));
      } else {
        startParams =
          'bankid:///?autostarttoken=' + autoStartToken + '&redirect=null';
      }
      return startParams;
    },
    templateContext: function() {
      var fallbackStartUrl = this.getBankIDStartParams();
      var fallbackLinkClass;
      if (svs.core.detect.formfactor.mobile()) {
        fallbackLinkClass =
          'animate animate-show animate-time-long animate-delay-5s margin-xs-top-2';
      } else {
        fallbackLinkClass = 'margin-xs-top-2';
      }
      return {
        fallbackStartUrl: fallbackStartUrl,
        fallbackLinkClass: fallbackLinkClass
      };
    },
    onRender: function() {
      this.trigger('modalContentResize');
    },
    onAttach: function() {
      this.loader = new svs.components.Loader('.js-bankid-loader-large-inverted').show(300, 'inverted');
      if (svs.core.detect.formfactor.mobile()) {
        window.location.href = this.getBankIDStartParams();
      }
      this.getUI('ast').append('<input id="token-auto-test" value="' + this.getOption('autoStartToken') + '" />');
    },
    onDestroy: function() {
      this.loader.hide();
    }
  });
})(Backbone, svs);

 })(window);